import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilderModule } from '@rd/form-builder/form-builder.module';
import { DataTestidDirective } from '../../directives/data-testid/data-testid.directive';
import { PhysicalAddressFormComponent } from './physical-address-form.component';
import { PhysicalAddressFormService } from './physical-address-form.service';

@NgModule({
  declarations: [PhysicalAddressFormComponent],
  imports: [
    MatAutocompleteModule,
    CommonModule,
    DataTestidDirective,
    FormBuilderModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [PhysicalAddressFormComponent],
  providers: [PhysicalAddressFormService],
})
export class PhysicalAddressFormModule {}
